type Corners = "square" | "round";

export interface TagProps {
  children?: React.ReactNode;
  variant?: Corners;
}

const Tag = ({ variant = "square", children }: TagProps) => {
  return (
    <div
      className={`relative inline-flex select-none items-center justify-center bg-primary px-[1.25rem] py-[0.5rem] text-white ${variant === "round" ? "rounded-full" : "rounded-[0.5rem]"}`}
    >
      {children}
    </div>
  );
};

export default Tag;
